module.exports = __webpack_public_path__ + "img/安全高效的数据共享.9274fd76.png";